import React, { useEffect, useState } from 'react';
import { get } from '../../services/apiController';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';

const List = React.memo(({ items }) => {
  return items.map((item, index) => (
    <option key={index} value={item?.id}>
      {item?.name}
    </option>
  ));
});

const Company = ({ company, onChange, label, name, ...rest }) => {
  const [companies, setCompanies] = useState([]);
  const getCompanies = () => {
    try {
      get(`/companies`).then((response) => {
        setCompanies(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <Form.Select
      required={'required' in rest ? rest.required : false}
      disabled={'disabled' in rest ? rest.disabled : false}
      name={name}
      value={company}
      onChange={onChange}
      aria-label="Floating label select example"
      className="form-select"
    >
      <option value="">Select {label}</option>
      <List items={companies} />
    </Form.Select>
  );
};

export default React.memo(Company);
